<template>
    <b-card no-body>
        <apexchart
            type="area"
            height="100%"
            :options="chart.chartOptions"
            :series="chart.series"
        />
    </b-card>
</template>

<script>
export default {
    name: 'ScoreParticipationEvolution',
    props: {
        dates: {
            type: Array,
            default: () => [],
        },
        milestones: {
            type: Array,
            default: () => [],
        },
        participation: {
            type: Array,
            default: () => [],
        },
        score: {
            type: Array,
            default: () => [],
        },
        title: {
            type: String,
            default: 'Evolução da Pontuação',
        },
    },
    computed: {
        chart () {
            const chartData = {
                series: [],
                parentHeightOffset: 10,
                chartOptions: {
                    title: {
                        text: this.title,
                        align: 'left',
                        margin: 0,
                        offsetX: 0,
                        offsetY: 5,
                        floating: true,
                        style: {
                            fontSize: '18px',
                            fontWeight: '400',
                            fontFamily: 'Nunito',
                            color: '#263238',
                        },
                    },
                    chart: {
                        width: '100%',
                        height: '150px',
                        toolbar: {
                            show: false,
                        },
                        sparkline: {
                            enabled: true,
                        },
                    },
                    dataLabels: {
                        enabled: true,
                    },
                    legend: {
                        show: false,
                    },
                    xaxis: {
                        type: 'datetime',
                        categories: this.dates,
                        labels: {
                            show: false,
                        },
                        axisTicks: {
                            show: false,
                        },
                        axisBorder: {
                            show: false,
                        },
                    },
                    yaxis: {
                        min: 0,
                        max: 100,
                        forceNiceScale: true,
                        show: false,
                    },
                    grid: {
                        show: false,
                        padding: {
                            left: 10,
                            right: 10,
                            bottom: 10,
                            top: 12,
                        },
                    },
                    tooltip: {
                        enabled: true,
                        x: {
                            format: 'dd/MM/yy HH:mm',
                        },
                    },
                    colors: ['#6ed3cf', '#9068be'],
                    stroke: {
                        curve: 'straight',
                        width: 2,
                    },
                    fill: {
                        opacity: 0.5,
                    },
                    annotations: {},
                },
            }

            if (this.score.length) {
                chartData.series.push({
                    name: 'Pontuação',
                    data: this.score.map(score => +(score.toFixed(0))),
                })
            }

            if (this.participation.length) {
                chartData.series.push({
                    name: 'Participação',
                    data: this.participation.map(participation => +(participation.toFixed(0))),
                })
            }

            if (this.milestones.length) {
                chartData.chartOptions.annotations.xaxis = this.milestones
            }

            return chartData
        },
    },
}
</script>
